/* --------------------------------------------------------------------------
	Express
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var $Tabs, $TabList, $TabItem, $TabTrigger, $TabPanel;

	function init() {
		$Tabs = $('.js-express-tabs-block');

		if (!$Tabs.length) {
			return;
		}

		$TabList = $('.js-express-tabs');
		$TabItem = $('.js-express-tab');
		$TabTrigger = $('.js-express-tab-trigger');
		$TabPanel = $('.js-express-tab-panel');

		$TabTrigger
			.attr({
				role: 'tab',
				'aria-selected': 'false',
				tabindex: '-1'
			})
			.on('activate.swap', onTriggerActivate)
			.on('deactivate.swap', onTriggerDeactivate)
			.on('keydown', onTabListKeydown);

		$TabPanel
			.attr({
				role: 'tabpanel',
				tabindex: '-1',
				'aria-hidden': 'true'
			})
			.on('keydown', onTabPanelKeydown);

		$TabList.attr('role', 'tablist');

		$TabItem.attr('role', 'presentation');

		$TabItem.each(function () {
			$(this)
				.find('.js-express-tab-trigger')
				.attr('aria-controls', 'js-express-tab-panel-' + ($(this).index() + 1));
		});

		$TabPanel.each(function () {
			$(this).attr('aria-labelledby', 'js-express-tab-trigger-' + ($(this).index() + 1));
		});

		$Tabs.each(function () {
			$(this).find('.js-express-tab:eq(0) .js-express-tab-trigger').attr('aria-selected', 'true').removeAttr('tabindex');
			$(this).find('.js-express-tab-panel:eq(0)').attr('aria-hidden', 'false');
		});
	}

	function onTriggerActivate() {
		$(this).attr('aria-selected', 'true').removeAttr('tabindex');

		$Tabs.find($(this).data('swap-target')).attr('aria-hidden', 'false');
	}

	function onTriggerDeactivate() {
		$(this).attr({
			'aria-selected': 'false',
			tabindex: '-1'
		});

		$Tabs.find($(this).data('swap-target')).attr('aria-hidden', 'true');
	}

	function onTabListKeydown(e) {
		var tabIndex = $('.js-express-tab-trigger:focus').closest('.js-express-tab').index();
		var $tabsActive = $('.js-express-tab-trigger:focus').closest('.js-express-tabs-block');

		if (tabIndex >= 0) {
			if (e.keyCode === 37) {
				// left
				e.preventDefault();

				if (tabIndex > 0) {
					$tabsActive
						.find('.js-express-tab:eq(' + (tabIndex - 1) + ') .js-express-tab-trigger')
						.focus()
						.swap('activate');
				} else {
					$tabsActive.find('.js-express-tab:last-of-type .js-express-tab-trigger').focus().swap('activate');
				}
			} else if (e.keyCode === 39) {
				// right
				e.preventDefault();

				if (!$(this).closest('.js-express-tab').is(':last-of-type')) {
					$tabsActive
						.find('.js-express-tab:eq(' + (tabIndex + 1) + ') .js-express-tab-trigger')
						.focus()
						.swap('activate');
				} else {
					$tabsActive.find('.js-express-tab:first-of-type .js-express-tab-trigger').focus().swap('activate');
				}
			} else if (e.keyCode === 36) {
				// home
				e.preventDefault();

				$tabsActive.find('.js-express-tab:eq(0) .js-express-tab-trigger').focus().swap('activate');
			} else if (e.keyCode === 35) {
				// end
				e.preventDefault();

				$tabsActive.find('.js-express-tab:last-of-type .js-express-tab-trigger').focus().swap('activate');
			}
		}

		if (e.keyCode === 40) {
			// down
			e.preventDefault();

			$tabsActive = $('.js-express-tab-trigger:focus').closest('.js-express-tabs-block');
			var activeTab = $tabsActive.find('.js-express-tab-trigger.fs-swap-active').data('swap-target');

			$tabsActive.find(activeTab).focus();
		}
	}

	function onTabPanelKeydown(e) {
		if (e.keyCode === 38) {
			// up
			e.preventDefault();

			$(this).closest('.js-express-tabs-block').find('.js-express-tab-trigger.fs-swap-active').focus();
		}
	}

	Site.OnInit.push(init);
})(jQuery, Site);
